export enum ModulesSaveResultEnum {
  Success = 'success',
  Fail = 'fail',
}
